"use client";
import React, { createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
const steps = [
    {
        id: "define",
        title: "Define",
        label: "Define*",
        icon: "📋",
        isCompleted: false,
        isDisabled: false
    },
    {
        id: "package",
        title: "Package",
        label: "Package*",
        icon: "📦",
        isCompleted: false,
        isDisabled: false
    },
    {
        id: "choose",
        title: "Choose",
        label: "Choose*",
        icon: "✓",
        isCompleted: false,
        isDisabled: false
    },
    {
        id: "pallet",
        title: "Pallet",
        label: "Pallet*",
        icon: "📏",
        isCompleted: false,
        isDisabled: false
    },
    {
        id: "distribution",
        title: "Distribution Test",
        label: "Distribution Test*",
        icon: "🚛",
        isCompleted: false,
        isDisabled: false
    }
];

interface StepperContextType {
    currentStep: string;
    setCurrentStep: (step: string) => void;
    steps: typeof steps;
    setSteps: React.Dispatch<React.SetStateAction<typeof steps>>;
    handleNext: () => void;
    handleBack: () => void;
    handleStepClick: (stepId: string) => void;
    isStepDisabled: (stepId: string) => boolean;
    handleToPackage: () => void;
    spiderChartImage: string | null;
    setSpiderChartImage: (image: string | null) => void;
}

const StepperContext = createContext<StepperContextType | undefined>(undefined);

export const StepperProvider = ({ children }: { children: React.ReactNode }) => {
    const [currentStep, setCurrentStep] = useState("define");
    const [stepsState, setSteps] = useState(steps);
    const [spiderChartImage, setSpiderChartImage] = useState<string | null>(null);
    const dispatch = useDispatch();
    const pathname = useLocation();
    const handleNext = () => {
        const currentIndex = stepsState.findIndex((step) => step.id === currentStep);
        setCurrentStep(stepsState[currentIndex + 1].id);
        // if (currentIndex < stepsState.length - 1) {
        //     const nextStep = stepsState[currentIndex + 1].id;
        //     setCurrentStep(nextStep);
        //     setSteps((prevSteps) =>
        //         prevSteps.map((step, index) => ({
        //             ...step,
        //             isCompleted: index <= currentIndex
        //         }))
        //     );
        // }
    };
    const handleToPackage = () => {
        setCurrentStep("package");
    }
    const handleBack = () => {
        const currentIndex = stepsState.findIndex((step) => step.id === currentStep);
        if (currentIndex > 0) {
            const previousStep = stepsState[currentIndex - 1].id;
            setCurrentStep(previousStep);
        }
    };

    const handleStepClick = (stepId: string) => {
        if (!pathname.pathname.includes('new-project')) {
            setCurrentStep(stepId);
        } else {

        }
    };

    const isStepDisabled = (stepId: string) => {
        const stepIndex = stepsState.findIndex((step) => step.id === stepId);
        const currentIndex = stepsState.findIndex((step) => step.id === currentStep);
        return stepIndex > currentIndex + 1;
    };

    return (
        <StepperContext.Provider
            value={{
                currentStep,
                setCurrentStep,
                steps: stepsState,
                setSteps,
                handleNext,
                handleBack,
                handleStepClick,
                isStepDisabled,
                handleToPackage,
                spiderChartImage,
                setSpiderChartImage
            }}
        >
            {children}
        </StepperContext.Provider>
    );
};

export const useStepperContext = () => {
    const context = useContext(StepperContext);
    if (!context) {
        throw new Error("useStepperContext must be used within a StepperProvider");
    }
    return context;
};
